module.exports = __webpack_public_path__ + "media/audios/kid/lesson_8/audio_tpc8_volta-907aa0693b7977112c6fa84bacbbe22c.m4a";